export const GET_ALL_TAGS = 'GET_ALL_TAGS'
export const GET_SPECIFIC_TAG = 'GET_SPECIFIC_TAG'
export const GET_TAG_USE = 'GET_TAG_USE'
